module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-29-77f2b519b92277a6fe1c41e1fa647a0a.svg";